var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoudness = function SvgLoudness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.55 9.048H5.403a1.976 1.976 0 0 0-1.976 1.975v1.857c0 1.09.885 1.975 1.976 1.975h2.145c.342 0 .674.107.952.306l4.489 3.208c.373.267.891 0 .891-.46V5.995a.563.563 0 0 0-.891-.46L8.5 8.745a1.64 1.64 0 0 1-.95.304zm9.377.774c.39.616.617 1.346.617 2.13a3.96 3.96 0 0 1-.57 2.054m2.123-6.354a6.98 6.98 0 0 1 1.475 4.3c0 1.59-.53 3.056-1.421 4.23",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgLoudness as ReactComponent };
export default __webpack_public_path__ + "140704b33bc219ee2ec2d35cbae23ed9.svg";